import { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  // 1. Load from LocalStorage
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCart = localStorage.getItem('cartItems');
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) {
      return [];
    }
  });

  // 2. Save to LocalStorage
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    const { name, qtyType, qtyCount } = product;
    setCartItems((prevItems) => {
      const existingIndex = prevItems.findIndex(
        (item) => item.name === name && item.qtyType === qtyType
      );
      if (existingIndex !== -1) {
        const updated = [...prevItems];
        updated[existingIndex].qtyCount += qtyCount;
        return updated;
      } else {
        return [...prevItems, { ...product }];
      }
    });
  };

  const incrementQty = (index) => {
    setCartItems((prevItems) => {
      const updated = [...prevItems];
      updated[index].qtyCount += 1;
      return updated;
    });
  };

  const decrementQty = (index) => {
    setCartItems((prevItems) => {
      const updated = [...prevItems];
      if (updated[index].qtyCount > 1) {
        updated[index].qtyCount -= 1;
      }
      return updated;
    });
  };

  const removeFromCart = (index) => {
    setCartItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  // 3. Calculate Total Items for the Badge (FIX ADDED HERE)
  const cartCount = cartItems.reduce((total, item) => total + item.qtyCount, 0);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        setCartItems,
        addToCart,
        incrementQty,
        decrementQty,
        removeFromCart,
        cartCount, // <--- Exporting this makes the badge number appear!
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
